export default __webpack_public_path__ + "conveyor.png?79d640964c95440ec1e3d1f0ae72645b";